// featureFlags.js - Sovereign Modular Feature Flags for MeMark
// All extra functions are turned OFF by default for an ultra-clean, minimal experience.
// Users can toggle on any feature in Settings -> Features & Modules.

export const FEATURE_MODULES = [
  {
    id: 'aiAssistant',
    name: 'AI Copilot & Assistant',
    description: 'Conversational bookmark assistant, URL auto-tagging, and 1-click summarizer',
    iconName: 'FiCpu',
    badge: 'BYOK',
    defaultEnabled: false,
  },
  {
    id: 'terminal',
    name: 'Cyber Terminal CLI',
    description: 'Command line terminal interface with keyboard shortcuts (~ or `)',
    iconName: 'FiTerminal',
    badge: 'Pro CLI',
    defaultEnabled: false,
  },
  {
    id: 'pomodoro',
    name: 'Pomodoro Focus Timer',
    description: 'Interval reading sprints, focus timer with procedural alert sounds',
    iconName: 'FiClock',
    badge: 'Focus',
    defaultEnabled: false,
  },
  {
    id: 'lofi',
    name: 'Lo-Fi Chill Synthesizer',
    description: 'Procedural relaxing background chords & ambient vinyl beats',
    iconName: 'FiVolume2',
    badge: 'Audio Synth',
    defaultEnabled: false,
  },
  {
    id: 'binaural',
    name: 'Binaural Drone Generator',
    description: 'Alpha & theta wave frequency generator for deep research concentration',
    iconName: 'FiHeadphones',
    badge: 'Audio Synth',
    defaultEnabled: false,
  },
  {
    id: 'graphView',
    name: 'Spatial Mindmap Graph',
    description: 'Interactive 2D constellation graph connecting bookmarks by tags and folders',
    iconName: 'FiShare2',
    badge: 'Mindmap',
    defaultEnabled: false,
  },
  {
    id: 'carousel3d',
    name: '3D Carousel Perspective',
    description: 'Holographic 3D spinning carousel view for visual bookmark browsing',
    iconName: 'FiLayers',
    badge: '3D FX',
    defaultEnabled: false,
  },
  {
    id: 'terrain3d',
    name: '3D Knowledge Terrain',
    description: 'Topological 3D mesh map visualizing bookmark frequency and depth',
    iconName: 'FiCompass',
    badge: '3D FX',
    defaultEnabled: false,
  },
  {
    id: 'slideDeck',
    name: 'Slide Deck Presentation',
    description: 'Turn any folder of bookmarks into an interactive fullscreen slide show',
    iconName: 'FiTv',
    badge: 'Utility',
    defaultEnabled: false,
  },
  {
    id: 'scratchpad',
    name: 'Markdown Scratchpad',
    description: 'Slide-out quick notes scratchpad with local auto-saving markdown editor',
    iconName: 'FiFileText',
    badge: 'Notes',
    defaultEnabled: false,
  },
  {
    id: 'readingQueue',
    name: 'Reading List Drawer',
    description: 'Read-later drawer with estimated reading times and completion checklist',
    iconName: 'FiBookOpen',
    badge: 'Reading',
    defaultEnabled: false,
  },
  {
    id: 'vaultCrypto',
    name: 'Zero-Knowledge Vault',
    description: 'Client-side AES-GCM-256 encrypted credentials, master PIN & auto-clear clipboard',
    iconName: 'FiShield',
    badge: 'Crypto',
    defaultEnabled: false,
  },
  {
    id: 'soundFx',
    name: 'Web Audio Procedural Sounds',
    description: 'Crisp mechanical clicks, lock chimes, and micro auditory feedback',
    iconName: 'FiVolume1',
    badge: 'Audio',
    defaultEnabled: false,
  },
  {
    id: 'circadian',
    name: 'Ambient Chronos Phase',
    description: 'Circadian time tracker with dawn, day, dusk, and midnight status pill',
    iconName: 'FiSun',
    badge: 'Atmosphere',
    defaultEnabled: false,
  },
];

export const DEFAULT_FEATURES = {
  aiAssistant: false,
  terminal: false,
  pomodoro: false,
  lofi: false,
  binaural: false,
  carousel3d: false,
  terrain3d: false,
  graphView: false,
  slideDeck: false,
  scratchpad: false,
  readingQueue: false,
  vaultCrypto: false,
  soundFx: false,
  circadian: false,
};

const STORAGE_KEY = 'memark_features_config';

export function getEnabledFeatures() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return { ...DEFAULT_FEATURES, ...JSON.parse(raw) };
    }
  } catch (err) {
    console.warn('Failed to parse feature flags:', err);
  }
  return { ...DEFAULT_FEATURES };
}

export function saveEnabledFeatures(features) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(features));
    window.dispatchEvent(new CustomEvent('memark_features_updated', { detail: features }));
  } catch (err) {
    console.warn('Failed to save feature flags:', err);
  }
}
